import { render } from "./UserShowComponent.vue?vue&type=template&id=df6f9b76"
import script from "./UserShowComponent.vue?vue&type=script&lang=js"
export * from "./UserShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__